import { WIDGET_NAME } from "@constants"
import { PACKAGE_FALLBACK } from "../constants"
import { isDwebUrl } from "@lib/urlMatchUtility"

export const parseWidgetData = (widgets) => {
    let widgetArray = widgets?.map((widget) => {
        let widgetData
        switch (widget?.type) {
            case WIDGET_NAME.LabTestDescription: {
                widgetData = {
                    title: widget.data?.title,
                    ...(widget.data?.image
                        ? {
                              image: {
                                  url: widget.data.image?.url,
                                  altText: widget.data.image?.alt,
                              },
                          }
                        : {}),
                    video: {
                        src: widget.data?.video?.url,
                        fallbackImage: widget.data?.image?.url,
                    },
                    ctaAction: widget.data?.cta?.action,
                    ctaLabel: widget.data?.cta?.text,
                    ctaIcon: widget.data?.cta?.icon,
                    ctaTargetUrl: widget.data?.cta?.details?.target_url,
                    description: widget.data?.description,
                    recentlyBookedData: {
                        iconUrl: widget.data?.booking_count?.image?.url,
                        altText: widget.data?.booking_count?.image?.alt,
                        description: widget.data?.booking_count?.text,
                    },
                    certifications: widget.data?.certification?.map((certificate) => ({
                        iconUrl: certificate?.logo?.url,
                        altText: certificate?.logo?.alt,
                        header: certificate?.title,
                        description: certificate?.description,
                    })),
                    collapseContent: widget.data?.collapse_content,
                    is1mgLab: widget.data?.is_one_mg_lab,
                    lastUpdated: {
                        header: widget.data?.last_updated?.header,
                        value: widget.data?.last_updated?.value,
                    },
                    shareWebUrl: widget.data?.share_web_url,
                    ratingData: {
                        averageRating: widget.data?.rating?.overview?.value,
                        totalRating: widget.data?.rating?.overview?.out_of,
                        showText: widget.data?.rating?.overview?.display_text,
                    },
                    ratingModalData: {
                        Transparency: {
                            value: widget.data?.rating?.rating_summary?.transparency,
                            color: "#1aab2a",
                        },
                        Accreditations: {
                            value: widget.data?.rating?.rating_summary?.certifications,
                            color: "#1aab2a",
                        },
                        "User Reviews": {
                            value: widget.data?.rating?.rating_summary?.user_reviews,
                            color: "#1aab2a",
                        },
                    },
                }
                break
            }
            case WIDGET_NAME.WalkInDetails: {
                widgetData = {
                    header: widget.data?.header,
                    subHeading: widget.data?.sub_header,
                    details: widget.data?.data?.map((detail) => ({
                        detailType: detail.type,
                        imageUrl: detail.image?.url,
                        imageAlt: detail.image?.alt,
                        subText: detail.header,
                        description: detail.details,
                        ctaLabel: detail.cta?.text,
                        ctaAction: detail.cta?.action,
                        targetUrl: detail.cta?.details?.target_url,
                        ctaIcon: detail.cta?.icon,
                        isCtaEnabled: detail.cta ? true : false,
                        expandedView: detail.expanded_view?.map((item) => ({
                            key: {
                                text: item.key?.text,
                                color: item.key?.color,
                                bold: item.key?.bold,
                            },
                            subKey: item.sub_key
                                ? {
                                      text: item.sub_key?.text,
                                      color: item.sub_key?.color,
                                      bold: item.sub_key?.bold,
                                  }
                                : null,
                            value: {
                                text: item.value?.text,
                                color: item.value?.color,
                                bold: item.value?.bold,
                            },
                            subValue: item.sub_value
                                ? {
                                      text: item.sub_value?.text,
                                      color: item.sub_value?.color,
                                      bold: item.sub_value?.bold,
                                  }
                                : null,
                        })),
                    })),
                    isLoading: false,
                    isTextHidden: false,
                    variantSmall: true,
                }
                break
            }
            case WIDGET_NAME.ListOfFeatures: {
                widgetData = {
                    heading: widget.data?.heading,
                    disclaimer: widget.data?.disclaimer,
                    features: widget.data?.data?.map((feature) => ({
                        image: feature.image,
                        heading: feature.heading,
                        subHeading: feature.sub_heading,
                        information: feature.information,
                    })),
                    variant: "large",
                }
                break
            }
            case WIDGET_NAME.StillAndMovingImages: {
                widgetData = {
                    header: widget.data?.heading,
                    imagesUrl: widget.data?.data?.map((image) => ({
                        url: image.url,
                        imageAltText: image.alt,
                    })),
                    showArrows: true,
                }
                break
            }
            case WIDGET_NAME.FootNotes: {
                widgetData = {
                    header: widget.data?.header,
                    data: widget.data?.data?.map((data) => ({
                        header: data.header,
                        displayText: data.sub_header,
                    })),
                }
                break
            }
            case WIDGET_NAME.PanelDetails: {
                widgetData = {
                    header: widget.data?.header,
                    subHeader: widget.data?.sub_header,
                    detailsArray: widget.data?.data?.map((panel) => ({
                        imageUrl: panel.image?.url,
                        imageAlt: panel.image?.alt,
                        text: panel.header,
                        line1: panel.line1,
                        line2: panel.line2,
                        tags: panel.tags?.map((tag) => {
                            return {
                                item: tag.text,
                                bgColor: tag.bg_color,
                                color: tag.text_color,
                            }
                        }),
                    })),
                }
                break
            }
            case WIDGET_NAME.HorizontalPackageListing: {
                const parsedProductItems = {}
                const productItems = widget.data?.items
                for (const key in productItems) {
                    parsedProductItems[key] = productItems[key].map((product, index) => ({
                        id: `${product.id}_${product.lab.id}_${product.name}`,
                        image: {
                            url: product.image?.url || PACKAGE_FALLBACK,
                            alt: product.image?.alt,
                        },
                        ...(product?.tag
                            ? {
                                  tagInfo: {
                                      label: product.tag?.text,
                                      color: product.tag?.text_color,
                                      backgroundColor: product.tag?.bg_color,
                                      borderColor: product.tag?.border_color,
                                  },
                              }
                            : {}),
                        heading: product?.name,
                        subHeading: product?.line1,
                        description: product?.line2,
                        labInfo: {
                            image: product?.lab?.image,
                            name: product?.lab?.name,
                            id: product?.lab?.id,
                            rating: {
                                averageRating: product?.lab?.rating?.average_rating,
                                totalRatings: product?.lab?.rating?.total_ratings,
                                showText: false,
                                showRatingCount: false,
                            },
                        },
                        price: {
                            mrp: product?.price?.mrp,
                            discountedPrice: product?.price?.discounted_price,
                            discount: product?.price?.discount,
                            suffix: product?.price?.price_suffix,
                        },
                        ...(product?.sale
                            ? {
                                  tagInfo: {
                                      displayText: product.sale?.display_text,
                                      validity: product.sale?.validity,
                                  },
                              }
                            : {}),
                        stickyData: {
                            id: product?.id,
                            heading: product?.name,
                            subTitle: product?.line1,
                            name: product?.name,
                            category: product?.category,
                            slug: product?.slug,
                            image: { url: "FUNNEL_ICON", alt: product?.name },
                            gaAction: "Add to cart widget",
                            primaryCtaLabel: product?.primary_cta?.text,
                            secondaryCtaLabel: product?.secondary_cta?.text,
                            page: "lab details",
                            labId: product?.lab?.id,
                        },
                        buttonType: "secondary",
                        ctaLabel: product?.primary_cta?.text,
                        showAddToCartCTA: true,
                        payload: {
                            skus: [{ test_id: product.id.toString() }],
                        },
                        addSuccessFunctionMap: "addLabsSuccess",
                        deleteSuccessFunctionMap: "deleteLabsSuccess",
                        addErrorFunctionMap: "addLabsError",
                        responseType: "brief",
                        types: "labs",
                        mixPanelData: {
                            ...product?.mix_panel_data,
                            position: index,
                        },
                    }))
                }
                widgetData = {
                    header: widget.data?.heading,
                    selector: widget.data?.category_details,
                    redirectUrl: widget.data?.cta?.details?.target_url_web,
                    categoryId: widget.data?.id,
                    showMoreLabel: widget.data?.cta?.text,
                    itemsActive: widget.data?.category_details?.items?.filter((item) => {
                        return item?.is_active
                    }),
                    products: parsedProductItems,
                    mixPanelData: widget.data?.mix_panel_data,
                }
                break
            }
            case WIDGET_NAME.ListOfTestCarousel: {
                widgetData = {
                    heading: widget.data?.header,
                    subHeading: widget.data?.sub_header,
                    subType: widget.data?.sub_type,
                    showMoreLabel: widget.data?.cta?.text,
                    seeAllRedirectUrl: widget.data?.cta?.details?.target_url,
                    items: widget.data?.data?.map((result, index) => ({
                        id: result.id,
                        name: result.header,
                        subHeading: result.sub_header,
                        price: result.price?.mrp,
                        suffix: result.price?.price_suffix,
                        discountedPrice: result.price?.discounted_price,
                        discountPercent: result.price?.discount,
                        label: result.primary_cta?.text,
                        primaryCta: {
                            action: result.primary_cta?.action,
                            text: result.primary_cta?.text,
                            targetUrl: result.primary_cta?.details?.target_url,
                        },
                        secondaryCta: {
                            action: result.secondary_cta?.action,
                            text: result.secondary_cta?.text,
                            targetUrl: result.prsecondary_ctaimary_cta?.details?.target_url,
                        },
                        imageUrl: result.image?.url,
                        altText: result.image?.alt,
                        slug: result.url,
                        isExternal: !isDwebUrl(result.url),
                        category: result.category,
                        subCategory: widget.data?.header,
                        buttonType: "secondary",
                        payload: {
                            skus: [{ test_id: result.id.toString() }],
                        },
                        responseType: "brief",
                        types: "labs",
                        addSuccessFunctionMap: "addLabsSuccess",
                        deleteSuccessFunctionMap: "deleteLabsSuccess",
                        addErrorFunctionMap: "addLabsError",
                        mixPanelData: {
                            ...result?.mix_panel_data,
                            position: index,
                        },
                    })),
                    mixPanelData: widget.data?.mix_panel_data,
                }
                break
            }
            default: {
                widgetData = widget
            }
        }
        return { type: widget.type, data: widgetData }
    })
    return widgetArray
}

function parseColumn(columnData, columnNumber) {
    const finalColumnObj = { columnNumber: columnNumber }
    const finalWidgetArray = parseWidgetData(columnData.widgets)
    finalColumnObj["widgets"] = finalWidgetArray
    finalColumnObj["width"] = columnData.width
    return finalColumnObj
}

function parseRows(rowData, rowNumber) {
    const finalRowObj = { rowNumber: rowNumber }
    const finalColumnArray = rowData.columns.map((columnData) => {
        if (columnData.widgets) return parseColumn(columnData, columnData.column_no)
        else if (columnData.type)
            return { columnNumber: columnData.column_no, type: columnData.type, width: columnData.width }
    })
    finalRowObj["column"] = finalColumnArray
    return finalRowObj
}

export const parseLayoutData = (layoutData) => {
    let parsedLayoutData = {}
    const finalArray = layoutData.rows.map((rowData) => parseRows(rowData, rowData.row_no))
    parsedLayoutData["rows"] = finalArray
    return parsedLayoutData
}
